import { ISupportCategoryGroup, ISupportSubcategory } from 'generated/sanity-graphql';
import { Region } from 'utils/environment/types';

export interface ISupportFormData {
  comments: string;
  email: string;
  issueId: string;
  name: string;
  orderDate?: string;
  orderDateTime?: { day: string; month: string; year: string };
  agreesToTermsOfService?: boolean;
  serviceMode?: string;
  storeId?: string;
  storeAddress?: string;
}

export interface ISupportFormDefaultValues {
  email: string | null;
  supportCategoryGroup: string | null;
  supportSubcategory: string | null;
}

export enum CreateCaseState {
  ERROR,
  LOADING,
  SUCCESS,
  DEFAULT,
}

export interface ICreateSupportCaseInput extends Omit<ISupportFormData, 'orderDateTime'> {
  orderDateTime?: string;
  userRegion: Region;
  userAccountRegion: string | null;
}

export interface IUseCreateSupportCase {
  caseReferenceNumber: string | null | undefined;
  createCaseState: CreateCaseState;
  createSupportCase(caseInfo: ICreateSupportCaseInput): Promise<string | null | undefined>;
  createCaseError: string;
}

export type TLogSupportFormSubmission = ({
  caseRefNumber,
  formData,
  userIssue,
}: {
  caseRefNumber: string | null;
  formData: ISupportFormData;
  userIssue?: ISubcategory | null;
}) => void;

export interface ISubcategory {
  _id: string;
  name?: { locale: string | null } | null;
  knowledgeForceIssueId: ISupportSubcategory['knowledgeForceIssueId'];
  supportSubCategoryServiceModeSelector?: ISupportSubcategory['supportSubcategoryServiceModeSelector'];
}

export interface ICategoryGroup extends ISupportCategoryGroup {
  name: ISupportCategoryGroup['name'] & { locale: string };
}

/** Provider capabilities consumed by support case state. */
export interface SupportCaseProvider {
  createCase(caseInfo: ICreateSupportCaseInput): Promise<string | null | undefined>;
  handleError(error: unknown): string | undefined;
}
